type Translate = (key: string, values?: Record<string, any>) => string

// "just now", "5m ago", "3h ago", "4d ago" — shared by anywhere that shows a
// last-used/last-updated timestamp (order-form presets, the page-tabs drawer).
// `now` defaults to Date.now() and is only overridden by tests.
export function formatRelativeTime(
  epochMs: number | string | undefined,
  t: Translate,
  now: number = Date.now()
): string {
  if (epochMs === undefined) return ''
  const ms = typeof epochMs === 'string' ? Number(epochMs) : epochMs
  if (!ms) return ''

  const diff = now - ms
  const mins = Math.floor(diff / 60_000)
  if (mins < 1) return t('relativeTime.justNow')
  if (mins < 60) return t('relativeTime.minutesAgo', { count: mins })
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return t('relativeTime.hoursAgo', { count: hrs })
  return t('relativeTime.daysAgo', { count: Math.floor(hrs / 24) })
}
